import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { GoogleAdsPlaybook } from '../components/GoogleAdsPlaybook';
import { AdTermsGuide } from '../components/AdTermsGuide';
import { MetaAdsPlaybook } from '../components/MetaAdsPlaybook';
import { LSAPlaybook } from '../components/LSAPlaybook';
import { LocalSEOPlaybook } from '../components/LocalSEOPlaybook';

const GROUPS = [
  {
    label: 'Google',
    tabs: [
      { id: 'ppc', label: 'Google Ads' },
      { id: 'terms', label: 'Ad Words, Explained' },
      { id: 'lsa', label: 'Google Local Service Ads' },
      { id: 'seo', label: 'Get Found on Google' },
    ],
  },
  {
    label: 'Meta',
    tabs: [
      { id: 'meta', label: 'Facebook & Instagram Ads' },
    ],
  },
];

const TABS = GROUPS.flatMap((g) => g.tabs);

export default function Playbooks() {
  const [searchParams] = useSearchParams();
  const initial = TABS.some((t) => t.id === searchParams.get('tab')) ? searchParams.get('tab') : 'ppc';
  const [tab, setTab] = useState(initial);

  return (
    <Layout variant="light">
      <div className="max-w-6xl mx-auto px-6 py-8" data-testid="playbooks-page">
        <h1 className="text-4xl font-black text-white mb-2">Playbooks</h1>
        <p className="text-light-gray mb-8">
          Pick one channel. Follow the steps. That's it.
        </p>

        <div className="flex flex-wrap gap-x-8 gap-y-4 mb-8 border-b border-divider pb-4">
          {GROUPS.map((g) => (
            <div key={g.label}>
              <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-gray mb-2" data-testid={`playbooks-group-${g.label.toLowerCase()}`}>{g.label}</p>
              <div className="flex flex-wrap gap-2">
                {g.tabs.map((t) => (
                  <button
                    key={t.id}
                    onClick={() => setTab(t.id)}
                    data-testid={`playbooks-tab-${t.id}`}
                    className={`px-5 py-2.5 rounded-lg font-semibold transition-colors ${
                      tab === t.id ? 'bg-lime text-black' : 'text-light-gray hover:bg-slate-blue hover:text-white'
                    }`}
                  >
                    {t.label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {tab === 'ppc' && <div data-testid="playbooks-ppc-section"><GoogleAdsPlaybook /></div>}
        {tab === 'terms' && <div data-testid="playbooks-terms-section"><AdTermsGuide /></div>}
        {tab === 'meta' && <div data-testid="playbooks-meta-section"><MetaAdsPlaybook /></div>}
        {tab === 'lsa' && <div data-testid="playbooks-lsa-section"><LSAPlaybook /></div>}
        {tab === 'seo' && <div data-testid="playbooks-seo-section"><LocalSEOPlaybook /></div>}
      </div>
    </Layout>
  );
}
